export default __webpack_public_path__ + "1ad1b0b0c74fc6ef62bcf5e981d88f00.json";